module.exports = __webpack_public_path__ + "img/avatarFemelle.cf32aa2e.png";